export default "__VITE_ASSET__DVnwhxWl__"